export default "__VITE_ASSET__CVgHVDx___"